import { ChangeDetectorRef, Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues15, LocalService, Status, TriggeredEvent, Wrapper15 } from '../../../service/local.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-country-configuration',
  templateUrl: './country-configuration.component.html',
  styleUrls: ['./country-configuration.component.scss']
})
export class CountryConfigurationComponent implements OnInit {
  @ViewChild('content_country_configuration')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() id: string;

  lstSectionConfigKeys: string[] = ["country_popup"];
  wrapper: Wrapper15;  isAlphaNumericPostalCode = false;

  constructor(private offcanvasService: NgbOffcanvas, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private countryManagementService: CountryManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: { key: '', v1: '', v2: null, v3: '', v4: '', v5: '', v6: '', v7: '', v8: '1', v9: '2', v10: '3', v11: '0', v12: '0' } as KeyValues15,
        timeZones: [] as number[]
      } as Wrapper15;
    }
    else {
      this.countryManagementService.getCountry(this.id).subscribe(result => {
        this.wrapper = result;
        this.isAlphaNumericPostalCode = this.wrapper.content.v11 && this.wrapper.content.v11 == '1';
      });
    }
  }

  onValuesUpdated(values: any, index) {
    switch (index) {
      case 1: {
        this.wrapper.timeZones = values;
      } break;
    }
  }

  onPopupClose() {
    this.onCloseTrigger({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.wrapper.content.v11 = this.isAlphaNumericPostalCode ? '1' : '0';
    this.countryManagementService.saveCountry(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        this.onCloseTrigger({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }
    });
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
